// extracted by mini-css-extract-plugin
export var button = "_5x-4";
export var hasDarkBackground = "_5x-7";
export var hasLightBackground = "_5x-6";
export var iconWrapper = "_5x-0";
export var large = "_5x-2";
export var medium = "_5x-1";
export var small = "_5x-5";
export var xsmall = "_5x-3";